/* global CONFIG */
import moment from 'moment'
import momentTz from 'moment-timezone' // eslint-disable-line
import services from './services'
import ft from './featureToggle'
import currencySymbol from '@/data/currency.js'

export default {
  getRsvpData(VueApp, rsvpId, callback) {
    let self = this
    VueApp.$sdk.get('/admin/rsvp/' + rsvpId, {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      if (res.error) {
        callback(res)
        return
      }
      setTimeout(() => {
        let serviceType = res.serviceCode === 'suv' ? 'SUV' : res.serviceCode
        let isAirportPickup = res.airline !== '' && res.airline !== null
        let isAirportDropoff = false
        let aptGate = ''
        let aptGateDropoff = ''
        let pickupTitle = self.buildLocation(res.pickupLocation)
        if (!isAirportPickup && pickupTitle.title && pickupTitle.title.indexOf('Apt/Gate:') > -1) {
          aptGate = pickupTitle.title.split(' Apt/Gate: ')[1]
        }
        if (!isAirportPickup && res.dropoffAirline) {
          isAirportDropoff = true
        }
        let dropoffTitle = self.buildLocation(res.dropoffLocation)
        if (!isAirportDropoff && dropoffTitle.title && dropoffTitle.title.indexOf('Apt/Gate:') > -1) {
          aptGateDropoff = dropoffTitle.title.split(' Apt/Gate: ')[1]
        }

        // let pickupMoment = moment(res.pickupDate, 'YYYY-MM-DD hh:mm:ss')
        let threshold = VueApp.$store.state.routing.beThereTimeThreshold
        let maxDuration = Math.floor(res.etaInSec * threshold)
        let btt = moment(res.pickupDate, 'YYYY-MM-DD HH:mm:ss').add(maxDuration, 'seconds').subtract(1, 'minute').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false))
        let flightName = res.airline || ''
        let flightNumber = res.flightNumber || ''
        if (flightNumber === 'N/A') flightNumber = ''
        if (flightName === 'N/A') flightName = ''
        if (!flightName && res.dropoffAirline) { flightName = res.dropoffAirline }
        if (!flightNumber && res.dropoffFlightNumber) { flightNumber = res.dropoffFlightNumber }
        let onboard = res.onboard ? moment(res.onboard, 'YYYY-MM-DD@hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)) : ''
        let mobile = 'N/A'
        let countryCode = ''
        let nationalNumber = ''
        if (res.consumer.phones.length) {
          mobile = res.consumer.phones[0].countryCode + '' + res.consumer.phones[0].phoneNumber
          countryCode = res.consumer.phones[0].countryCode
          nationalNumber = res.consumer.phones[0].nationalNumber || res.consumer.phones[0].phoneNumber
        }
        let fare = res.payment.fareAmount
        let driverPayment = res.payment.driverPay
        if (res.optinShared && res.optinShared.isOptinShared && res.optinShared.current === 'shared') {
          fare = res.optinShared.exclusive.amount
          driverPayment = res.optinShared.exclusive.driverPayment
        }
        let rsvpDetails = {
          rsvpId: res.ID,
          basicInfo: {
            tripInfo: {
              id: res.ID,
              brandId: res.brand.id,
              brand: res.brand.name,
              brandColor: res.brand.brandColor,
              packageId: res.packageID,
              bookedThrough: self.bookThroughLabel(res.bidDeviceType),
              status: res.status,
              bidStatus: res.dispatchStatus,
              bidId: res.bidID,
              created: moment(res.created, 'YYYY-MM-DD@hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
              canceled: res.canceled ? moment(res.canceled, 'YYYY-MM-DD@hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)) : '',
              pickupDate: moment(res.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
              fare: fare,
              driverPayment: driverPayment,
              driverBonus: res.payment.driverBonus || 0,
              paymentBonus: res.bonus.amount || 0,
              basePay: res.bonus.basePay || 0,
              meetAndGreet: res.pickupType === 'MeetAndGreet',
              tip: res.payment.tipAmount,
              airportFee: res.airportFee,
              gasFee: res.gasFee || 0,
              travelInsurance: res.travelInsurance ? res.travelInsurance : 0,
              pickupFee: res.payment.pickupFee,
              credits: res.payment.credits,
              serviceTypeId: res.serviceType.id,
              serviceType: serviceType,
              serviceLabel: services.getServiceName(res.serviceCode),
              serviceCode: res.serviceCode,
              pickup: self.buildLocation(res.pickupLocation),
              dropoff: self.buildLocation(res.dropoffLocation),
              aptGate: aptGate,
              aptGateDropoff: aptGateDropoff,
              eta: res.etaInSec,
              beThereTime: btt,
              distance: res.distance,
              isAsap: res.isAsap,
              airline: flightName,
              airlineCode: res.airlineCode,
              airportCode: res.airportCode,
              isAirportPickup: isAirportPickup,
              isAirportDropoff: isAirportDropoff,
              flightNo: flightNumber,
              terminal: res.terminal,
              passenger: res.passengers,
              luggage: res.luggage,
              notes: res.notes,
              serviceArea: res.pricingGeofence.name,
              wheelchair: res.ada.wheelChairLift !== 0,
              serviceDog: res.ada.serviceDog !== 0,
              overridePrice: res.overridePrice,
              overridePayment: res.overridePayment,
              rating: res.rating.value,
              userReview: res.rating.message,
              onboard: onboard,
              reservationState: res.reservationState,
              paxReason: res.paxReason,
              extraStops: [],
              isCharter: res.isCharter,
              isRental: res.isRental,
              maxConcurrent: res.maxConcurrent,
              optinShared: res.optinShared,
              isMtech: res.isMTech || false,
              d2dId: res.d2dId || '',
              portalFee: res.portalFee || 0,
              paymentTotal: res.payment.total
            },
            customerInfo: {
              id: res.consumer.ID,
              firstName: res.consumer.firstName,
              lastName: res.consumer.lastName,
              creditCard: res.cardNumber,
              cardTitle: res.cardTitle,
              creditCardId: res.cardID,
              email: res.consumer.email,
              mobile: mobile,
              phone: {
                countryCode: countryCode,
                number: nationalNumber
              }
            },
            guestInfo: {
              firstName: res.guest.firstName,
              lastName: res.guest.lastName,
              mobile: res.guest.phone
            },
            businessInfo: {
              id: res.corporateProfile ? res.corporateProfile.id : '',
              corporateName: res.corporateProfile ? res.corporateProfile.name : '',
              firstName: res.guest.firstName,
              lastName: res.guest.lastName,
              mobile: res.guest.phone
            },
            driverInfo: {
              id: res.provider.ID,
              driverNum: res.provider.driverNum || res.provider.ID,
              firstName: res.provider.firstName,
              lastName: res.provider.lastName,
              rating: res.provider.rating,
              licensePlate: res.vehicle.plate,
              make: res.vehicle.manufacturer,
              model: res.vehicle.model,
              email: res.provider.email,
              mobile: res.provider.displayPhone,
              photo: res.provider.avatarUrl,
              vehiclePhoto: res.vehicle.photo,
              countryCode: res.provider.phones.length ? res.provider.phones[0].countryCode : '',
              nationalNumber: res.provider.phones.length ? res.provider.phones[0].nationalNumber || res.provider.phones[0].phoneNumber : '',
              number: res.provider.phones.length ? res.provider.phones[0].nationalNumber || res.provider.phones[0].phoneNumber : ''
            },
            otherInfo: {
              externalId: res.externalId || 'N/A',
              alternatePhone: res.alternatePhone || 'N/A'
            }
          }
        }
        if (!CONFIG.useOldQuatation) {
          rsvpDetails.basicInfo.tripInfo.serviceType = {
            label: res.serviceType.label,
            color: res.serviceType.color
          }
          if (res.serviceType.id > 5) {
            rsvpDetails.basicInfo.tripInfo.serviceCode = 'a' + res.serviceType.id
          }
        }
        if (CONFIG.brands.find(x => x.id === res.brandID) && res.pickupTimezone) {
          rsvpDetails.basicInfo.tripInfo.localPickupTime = moment(res.pickupDate, 'YYYY-MM-DD HH:mm:ss Z').tz(res.pickupTimezone).format('MM/DD/YYYY hh:mmA')
        }

        VueApp.$store.commit('rsvpDetails/setIsTerminal', res.isTerminal)
        VueApp.$store.commit('rsvpDetails/setRsvpDetails', rsvpDetails)
        VueApp.$store.commit('rsvpDetails/setMtechData', {enabled: res.isMTech})
        if (res.isMTech) {
          VueApp.$store.commit('rsvpDetails/setMtechData', {
            details: {
              localPickupDate: moment(res.pickupDate, 'YYYY-MM-DD HH:mm:ss Z').tz(res.pickupTimezone).format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
              timezone: res.pickupTimezone,
              service: res.mtechProductData
            }
          })
        }
        self.checkCurrency(VueApp, rsvpId, callback, res)
      }, 600)
    })
  },
  getTransactionByRsvpId(VueApp, rsvpId, callback) {
    let self = this
    VueApp.$sdk.get('/transaction', {
      token: VueApp.$store.state.session.sessionToken,
      rsvpId: rsvpId,
      order: 'created',
      orderAsc: 0
    }, res => {
      for (let i in res.list) {
        let trx = res.list
        let payment = trx[i].payment
        VueApp.$store.commit('rsvpDetails/addTransaction', {
          id: trx[i].id,
          date: moment(trx[i].datetime, 'YYYY-MM-DD@hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, true)),
          trxId: trx[i].eventId,
          cardId: trx[i].cardNumber,
          fare: self.toFixed(payment.offer),
          paid: self.toFixed(payment.charged),
          cancelFee: self.toFixed(payment.cancelFee),
          bonus: self.toFixed(payment.bonus),
          promoUsed: self.toFixed(payment.credit),
          status: trx[i].transactionType,
          statusLabel: trx[i].status,
          paymentURL: trx[i].paymentURL,
          notes: trx[i].notes,
          transactionType: trx[i].transactionType
        })
      }
      callback(res)
    })
  },
  getNotesByRsvpId(VueApp, rsvpId, callback) {
    VueApp.$sdk.get('/admin/rsvp/' + rsvpId + '/notes', {
      token: VueApp.$store.state.session.sessionToken,
      order: 'created',
      orderAsc: 0
    }, res => {
      for (let i in res.list) {
        let notes = res.list
        let date = moment.utc(notes[i].created, 'YYYY-MM-DD@hh:mm:ss').tz('America/Los_Angeles')
        let admin = {
          name: 'Deleted Admin',
          id: 0,
          pic: 'https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/default-user.jpg'
        }
        if (notes[i].admin) {
          admin = {
            name: notes[i].admin.firstName + ' ' + notes[i].admin.lastName,
            id: notes[i].admin.id,
            pic: notes[i].admin.avatarUrl
          }
        }
        VueApp.$store.commit('rsvpDetails/addNotes', {
          id: notes[i].id,
          date: date.format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
          message: notes[i].message,
          status: notes[i].status,
          userId: admin.id || 0,
          name: admin.name,
          picture: admin.pic || 'https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/default-user.jpg'
        })
      }
      callback(res)
    })
  },
  getFlightStatus(VueApp, param, callback) {
    VueApp.$sdk.get(
      '/availability/flights/' + param.flightCode + '?date=' + param.date + '&time=' + param.time + '&departure=' + param.isDeparture + '&airport=' + param.airportCode,
      {},
      res => {
        if (!res.error) {
          let date = param.isDeparture === '1' ? res.departure.time.unix : res.arrival.time.unix
          let arrival = moment(date, 'X', res.departure.time.timezone)
          VueApp.$store.commit('rsvpDetails/setFlightStatus', {
            status: res.status === 'InGate' ? 'Arrived' : res.status,
            departureAirport: res.departure.airportName + ' (' + res.departure.airportCode + ')',
            arrivalAirport: res.arrival.airportName + '(' + res.arrival.airportCode + ')',
            arrivalTime: arrival.format(ft.timeFormat(VueApp, false))
          })
        }

        callback(res)
      })
  },
  deleteNote(VueApp, noteId, callback) {
    VueApp.$sdk.delete('/note/' + noteId, {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('rsvpDetails/deleteNote', noteId)
      }
      callback(res)
    })
  },
  bookThroughLabel(type) {
    if (type === 'ww') return 'Web Browser'
    if (type === 'ios') return 'iOS APP'
    if (type === 'android') return 'Android APP'
    if (type === 'admin') return 'Admin'
    if (type === 'provider') return 'Provider'
    return type
  },
  buildLocation(data) {
    return {
      airportCode: data.airportCode,
      address1: data.addressLine1,
      address2: data.addressLine2,
      city: data.city,
      country: data.country,
      geofenceId: data.geofenceId,
      geofenceName: data.geofenceName,
      geofenceType: data.geofenceType,
      lat: data.lat,
      lng: data.lng,
      state: data.state,
      title: data.geofenceType === 'airport' ? data.geofenceName : data.title,
      zip: data.zip
    }
  },
  toFixed(value) {
    value = parseFloat(value)
    if (value < 0) {
      return '-$' + Math.abs(value).toFixed(2)
    }
    return '$' + value.toFixed(2)
  },
  sendEmail(VueApp, rsvpId, callback) {
    VueApp.$sdk.post('/admin/rsvp/' + rsvpId + '/email', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  sendTripReminder(VueApp, rsvpId, callback) {
    VueApp.$sdk.post('/admin/rsvp/' + rsvpId + '/reminder', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  sendNoShow(VueApp, rsvpId, callback) {
    VueApp.$sdk.post('/admin/rsvp/' + rsvpId + '/noshow', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  checkCurrency(VueApp, id, callback, data) {
    let self = this
    VueApp.$sdk.get(`/admin/rsvp/${id}/currency`, {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('rsvpDetails/setCurrency', {
          airportFee: res.airportFee || 0,
          amount: res.amount || 0,
          credit: res.credit || 0,
          currency: res.currency || 'USD',
          currencyRate: res.currencyRate || 1,
          gasFee: res.gasFee || 0,
          pickupFee: res.pickupFee || 0,
          tipAmount: res.tipAmount || 0,
          travelInsurance: res.travelInsurance || 0,
          symbol: res.currency ? currencySymbol[res.currency] : '$'
        })
        if (res.currency !== 'USD') {
          self.getCurrencyList(VueApp, callback, data)
          return
        }
      }
      callback(data)
    })
  },
  getCurrencyList (VueApp, callback, data) {
    let currency = VueApp.$store.state.currency
    let lastUpdate = moment(currency.lastUpdate, 'MM/DD/YYYY hh:mmA')
    let now = momentTz.tz('America/Los_Angeles')
    let updateTime = momentTz.tz(`${now.format('MM/DD/YYYY')} 04:30AM`, 'MM/DD/YYYY hh:mmA', 'America/Los_Angeles')
    if (
      !lastUpdate || lastUpdate.format('MM/DD/YYYY') !== now.format('MM/DD/YYYY') ||
      (
        lastUpdate.format('MM/DD/YYYY') === now.format('MM/DD/YYYY') &&
        now.diff(updateTime, 'minutes') > 0 && lastUpdate.diff(updateTime, 'minutes') < 0
      )
    ) {
      VueApp.$store.commit('currency/setCurrencyData', {loading: true})
      try {
        VueApp.$sdk.get('exchangerate', {}, r => {
          VueApp.$store.commit('currency/setCurrencyData', {loading: false})
          if (!r.error) {
            VueApp.$store.commit('currency/setCurrencyData', {
              list: r,
              lastUpdate: now.format('MM/DD/YYYY hh:mmA')
            })
          }
          callback(data)
        }, '')
      } catch (err) {
        VueApp.$store.commit('global/setAlertData', {
          show: true,
          message: err
        })
        callback(data)
      }
      return
    }
    callback(data)
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/reservations.js